import { saveAs } from 'file-saver';
import { Workbook, Worksheet } from "exceljs";
import header from "../Header";
import { ConfigTable, generaTabla } from "../generateTable";
import { styles as sg } from "../styles";
import { Usuario } from "../../../../types/admin-usuarios/Usuario";

export default async function Usuarios(data: Usuario[]){
    const workbook = new Workbook();
    const sheet = header(workbook, "Usuarios");

    let row = 3;
    if(true){
        const usuarios = data.map((item, ix) => {
            return { ...item, _id: ix + 1 }
        });
        const configA: ConfigTable = {
            columns: [
                {data: "_id", title: "#", width: 30, align: "tCenter"},
                {data: "fullname", title: "Nombre completo", width: 30, align: "tCenter"},
                {data: "email", title: "Correo electrónico", width: 30, align: "tCenter"},
                {data: "phone", title: "Teléfono", width: 20, align: "tCenter"},
            ]
        }
        vtCabecera(sheet, row, "Plantilla de usuarios");
        row = generaTabla(usuarios, configA, sheet, row+2);
    }

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `Usuarios-${new Date().getFullYear()}.xlsx`);
}

function vtCabecera(sheet: Worksheet, row: number, title: string){
    sheet.mergeCells(row, 1, row, 4);
    const cellA = sheet.getRow(row).getCell(1);
    cellA.value = title;
    cellA.font = sg.font.tBold;
    cellA.alignment = sg.alignment.tCenter;
}

